import { render, staticRenderFns } from "./ExposeTab.vue?vue&type=template&id=6c0de25e"
import script from "./ExposeTab.vue?vue&type=script&lang=js"
export * from "./ExposeTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports